/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState, UI_KEY } from './ui.reducer';

const getState = createFeatureSelector<UiState>(UI_KEY);
export const getUiState = createSelector(getState, (state: UiState) => state);
